import { Select, SelectProps } from '@shared/Form/Select'
import { useDemandResponseTypeEnum } from '@services/operation'
import { useTranslation } from 'react-i18next'

type Props = {
  isDesc?: boolean
  showAll?: boolean
} & SelectProps

export const ParkingLotDemandResponseTypeSelect = (props: Props) => {
  const { isDesc = false, showAll = false, ...otherProps } = props
  const { t } = useTranslation()
  const { data } = useDemandResponseTypeEnum({ isDesc })

  return (
    <Select className="w-full" allowClear {...otherProps}>
      {showAll && (
        <Select.Option key="all" value="">
          {t('common:all')}
        </Select.Option>
      )}
      {data.map(x => (
        <Select.Option key={x.id} value={x.id}>
          <div className="flex items-center">
            <span className={isDesc ? 'text-primaryYellow' : 'text-white'}>
              {x?.label}
            </span>
            <span>{x?.desc}</span>
          </div>
        </Select.Option>
      ))}
    </Select>
  )
}

export default ParkingLotDemandResponseTypeSelect
